import { fetchDataWithParams } from "../../../shared/services/service";
import type { HullCleaningDashboard } from "../models/hull-cleaning-dashboard.models";

export async function getHullCleaningDashboard(): Promise<HullCleaningDashboard> {
  const response = await fetchDataWithParams("pbi/hull-cleaning/dashboard");

  return response.data as HullCleaningDashboard;
}
